"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEA = getEA;
const chemical_elements_1 = require("chemical-elements");
const chemical_groups_1 = require("chemical-groups");
const Kind_1 = require("../Kind");
const getIsotopeRatioInfo_1 = require("./getIsotopeRatioInfo");
/**
 * @param {*} parts
 */
function getEA(parts) {
    let results = {};
    for (let part of parts) {
        for (let line of part) {
            switch (line.kind) {
                case Kind_1.Kind.ISOTOPE: {
                    let isotope = chemical_elements_1.isotopesObject[line.value.isotope + line.value.atom];
                    if (!isotope) {
                        throw new Error(`Unknown isotope: ${line.value.isotope}${line.value.atom}`);
                    }
                    addMass(results, line.value.atom, isotope.mass * line.multiplier);
                    break;
                }
                case Kind_1.Kind.ISOTOPE_RATIO: {
                    let isotopeRatioInfo = (0, getIsotopeRatioInfo_1.getIsotopeRatioInfo)(line.value);
                    addMass(results, line.value.atom, isotopeRatioInfo.mass * line.multiplier);
                    break;
                }
                case Kind_1.Kind.ATOM: {
                    let element = chemical_elements_1.elementsObject[line.value];
                    if (!element) {
                        element = chemical_groups_1.groupsObject[line.value];
                        if (!element)
                            throw new Error(`Unknown element: ${line.value}`);
                        // need to explode group ????
                    }
                    addMass(results, line.value, element.mass * line.multiplier);
                    break;
                }
                case Kind_1.Kind.CHARGE:
                    break;
                default:
                    throw new Error('partToMF unhandled Kind: ', line.kind);
            }
        }
    }
    let eas = [];
    let sum = 0;
    for (let key in results) {
        sum += results[key];
        eas.push({
            element: key,
            mass: results[key],
        });
    }
    for (const ea of eas) {
        ea.ratio = ea.mass / sum;
    }
    return eas;
}
function addMass(results, atom, mass) {
    if (!results[atom])
        results[atom] = 0;
    results[atom] += mass;
}
//# sourceMappingURL=getEA.js.map